import { render, staticRenderFns } from "./UCContactForm.vue?vue&type=template&id=52165e82&scoped=true&"
import script from "./UCContactForm.vue?vue&type=script&lang=ts&"
export * from "./UCContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./UCContactForm.vue?vue&type=style&index=0&id=52165e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52165e82",
  null
  
)

export default component.exports